exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PartnerInfo {\n  max-width: 900px;\n  margin: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/admin/components/PartnerInfo.less
// module id = 1341
// module chunks = 0